import { CobroService } from "src/app/services/cobranza/cobro.service";
import { TransaccionModel } from "../transaccion.model";
import { IResponse } from "src/app/pages/base/interfaces";
import { FormControl, FormGroup, Validators } from "@angular/forms";


export class Cobro extends TransaccionModel {

    public static RECORD_NAME = 'cobros';
    public static CODIGO_REGISTRO = 'cobro';
    public static CODIGO_MODULO = 'cobranza';
    public static NOMBRE_SINGULAR = 'Cobro';
    public static NOMBRE_PLURAL = 'Cobros';
    

    public static ESTADO_IMPRESION_PENDIENTE = 1;
    public static ESTADO_IMPRESION_IMPRESO = 2;
    public static ESTADO_IMPRESION_REIMPRESO = 3;

    public static ENABLE_FIELDS: string[] = ['fecha_transaccion'];
    public static DISABLE_FIELDS: string[] = ['fecha_transaccion'];


    public static ESTADO_IMPRESION = [
        { valor: 1, nombre: 'PENDIENTE' },
        { valor: 2, nombre: 'IMPRESO' },
        { valor: 3, nombre: 'REIMPRESO' },
    ];
    

    private _idEmpresa:                     number;
    private _nombreEmpresa:                 string;
    private _idSucursal:                    number;
    private _nombreSucursal:                string;
    private _idComercio:                    number;
    private _codigoComercio:                string;
    private _nombreComercio:                string;
    private _referencia:                    string;
    private _idServicio:                    number;
    private _codigoServicio:                string;
    private _nombreServicio:                string;
    private _idArqueoCaja:                  number;
    private _nroTrxArqueo:                  string;
    private _idCaja:                        number;
    private _nombreCaja:                    string;
    private _estadoImpresion:               number;
    private _importe:                       number;
    private _cobrado:                       number;
    private _vuelto:                        number;
    private _comisionComercio:              number;
    private _comisionServicio:              number;
    private _comisionBoca:                  number;
    private _nroTrxExterno:                 string;
    private _infoExterno:                   string;
    private _recibido:                      number;


    constructor() {
        super();
        const currentUser = this.seguridad.getCurrentUser();
        this._idEmpresa = currentUser.id_empresa;
        this._nombreEmpresa = currentUser.empresa.nombre;
        this._idSucursal = currentUser.id_sucursal;
        this._nombreSucursal = currentUser.sucursal.nombre;
        this._estadoImpresion = 1;
        this._cobrado = 0;
        this._importe = 0;
        this._vuelto = 0;
        this._recibido = 0;
        this._comisionComercio = 0;
        this._comisionServicio = 0;
        this._comisionBoca = 0;
    }

    public set idEmpresa( idEmpresa: number ) { this._idEmpresa = idEmpresa; }
    public get idEmpresa(): number { return this._idEmpresa; }

    public set nombreEmpresa( nombreEmpresa: string ) { this._nombreEmpresa = nombreEmpresa; }
    public get nombreEntidad(): string { return this._nombreEmpresa; }

    public set idSucursal( idSucursal: number ) { this._idSucursal = idSucursal; }
    public get idSucursal(): number { return this._idSucursal; }

    public set nombreSucursal( nombreSucursal: string ) { this._nombreSucursal = nombreSucursal; }
    public get nombreSucursal(): string { return this._nombreSucursal; }

    public set idComercio( idComercio: number ) { this._idComercio = idComercio; }
    public get idComercio(): number { return this._idComercio; }
    
    public set codigoComercio( codigoComercio: string ) { this._codigoComercio = codigoComercio }
    public get codigoComercio(): string { return this._codigoComercio }

    public set nombreComercio( nombreComercio: string ) { this._nombreComercio = nombreComercio; }
    public get nombreComercio(): string { return this._nombreComercio; }
    
    public set referencia( referencia: string ) { this._referencia = referencia };
    public get referencia(): string { return this._referencia };

    public set idServicio( idServicio: number ) { this._idServicio = idServicio };
    public get idServicio(): number { return this._idServicio };

    public set codigoServicio( codigoServicio: string ) { this._codigoServicio = codigoServicio }
    public get codigoServicio(): string { return this._codigoServicio }

    public set nombreServicio( nombreServicio: string ) { this._nombreServicio = nombreServicio };
    public get nombreServicio(): string { return this._nombreServicio };

    public set idArqueoCaja( idArqueoCaja: number ) { this._idArqueoCaja = idArqueoCaja };
    public get idArqueoCaja(): number { return this._idArqueoCaja };

    public set nroTrxArqueo( nroTrxArqueo: string ) { this._nroTrxArqueo = nroTrxArqueo };
    public get nroTrxArqueo(): string { return this._nroTrxArqueo };

    public set idCaja( idCaja: number ) { this._idCaja = idCaja };
    public get idCaja(): number { return this._idCaja };

    public set nombreCaja( nombreCaja: string ) { this._nombreCaja = nombreCaja };
    public get nombreCaja(): string { return this._nombreCaja };
    
    public set estadoImpresion( estadoImpresion: number ) { this._estadoImpresion = estadoImpresion; }
    public get estadoImpresion(): number { return this._estadoImpresion;}

    public set importe( importe: number ) { this._importe = importe };
    public get importe(): number { return this._importe };

    public set cobrado( cobrado: number ) { this._cobrado = cobrado };
    public get cobrado(): number { return this._cobrado };

    public set recibido( recibido: number ) { this._recibido = recibido };
    public get recibido(): number { return this._recibido };

    public set vuelto( vuelto: number ) { this._vuelto = vuelto };
    public get vuelto(): number { return this._vuelto };

    public set comisionComercio( comisionComercio: number ) { this._comisionComercio = comisionComercio };
    public get comisionComercio(): number { return this._comisionComercio };

    public set comisionServicio( comisionServicio: number ) { this._comisionServicio = comisionServicio };
    public get comisionServicio(): number { return this._comisionServicio };

    public set comisionBoca( comisionBoca: number ) { this._comisionBoca = comisionBoca };
    public get comisionBoca(): number { return this._comisionBoca };

    
    public set nroTrxExterno( nroTrxExterno: string ) { this._nroTrxExterno = nroTrxExterno };
    public get nroTrxExterno(): string { return this._nroTrxExterno };
    
    public set infoExterno( infoExterno: string ) { this._infoExterno = infoExterno; }
    public get infoExterno(): string { return this._infoExterno;}
    


    public static get columsOnLista(): Record<string, any>[] {
        return [
            { field: 'nro_transaccion', label: 'Nro. Trx.', type: 'number' },
            { field: 'fecha_transaccion', label: 'Fecha Trx.', type: 'date' },
            { field: 'comercio.nombre', label: 'Comercio', type: 'ref', refName: 'Comercio'},
            { field: 'servicio.nombre', label: 'Servicio', type: 'ref', refName: 'Servicio'},
            { field: 'referencia', label: 'Referencia', type: 'text' },
            { field: 'info_externo', label: 'info Externo', type: 'text' },
            { field: 'importe', label: 'Monto', type: 'number' },
        ]
    }

    override async cargarObjeto( objeto: Record<string, any> ) {
        await super.cargarObjeto( objeto );                
        this._idEmpresa = objeto.id_empresa;
        this._nombreEmpresa = objeto.empresa.nombre;
        this._idSucursal = objeto.id_sucursal;
        this._nombreSucursal = objeto.sucursal.nombre;
        this._idCaja = objeto.id_caja;
        this._nombreCaja = objeto.caja.nombre;
        this._idComercio = objeto.id_comercio;
        this._codigoComercio = objeto.comercio.codigo;
        this._nombreComercio = objeto.comercio.nombre;
        this._idServicio = objeto.id_servicio;
        this._codigoServicio = objeto.servicio.codigo;
        this._nombreServicio = objeto.servicio.nombre;
        this._referencia = objeto.referencia;
        this._idArqueoCaja = objeto.id_arqueo_caja;
        this._nroTrxArqueo = objeto.arqueo_caja.nro_transaccion;
        this._estadoImpresion = objeto.estado_impresion;
        this._importe = objeto.importe;
        this._cobrado = objeto.cobrado;
        this._recibido = objeto.recibido;
        this._vuelto = objeto.vuelto;
        this._comisionComercio = objeto.comision_comercio;
        this._comisionServicio = objeto.comision_servicio;
        this._comisionBoca = objeto.comision_boca;
        this._nroTrxExterno = objeto.nro_trx_externo;
        this._infoExterno = objeto.info_externo;
    }

    /**
     * Retorna el formulario a utilizar en las ventanas
     * @returns FormGroup
     */
    override async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();
        fg.addControl("id_empresa", new FormControl(this._idEmpresa, Validators.required));
        fg.addControl("nombre_empresa", new FormControl(this._nombreEmpresa, Validators.required));
        fg.addControl("id_sucursal", new FormControl(this._idSucursal, Validators.required));
        fg.addControl("nombre_sucursal", new FormControl(this._nombreSucursal, Validators.required));
        fg.addControl("id_comercio", new FormControl(this._idComercio));
        fg.addControl("codigo_comercio", new FormControl(this._codigoComercio));
        fg.addControl("nombre_comercio", new FormControl(this._nombreComercio));
        fg.addControl("referencia", new FormControl(this._referencia));
        fg.addControl("id_servicio", new FormControl(this._idServicio, Validators.required));
        fg.addControl("codigo_servicio", new FormControl(this._codigoServicio, Validators.required));
        fg.addControl("nombre_servicio", new FormControl(this._nombreServicio, Validators.required));
        fg.addControl("id_arqueo_caja", new FormControl(this._idArqueoCaja, Validators.required));
        fg.addControl("nro_transaccion_arqueo", new FormControl(this._nroTrxArqueo, Validators.required));
        fg.addControl("id_caja", new FormControl(this._idCaja, Validators.required));
        fg.addControl("nombre_caja", new FormControl(this._nombreCaja, Validators.required));
        fg.addControl("estado_impresion", new FormControl(this._estadoImpresion, Validators.required));
        fg.addControl("importe", new FormControl(this._importe, Validators.required));
        fg.addControl("cobrado", new FormControl(this._cobrado, Validators.required));
        fg.addControl("recibido", new FormControl(this._recibido, Validators.required));
        fg.addControl("vuelto", new FormControl(this._vuelto, Validators.required));
        fg.addControl("comision_comercio", new FormControl(this._comisionComercio, Validators.required));
        fg.addControl("comision_servicio", new FormControl(this._comisionServicio, Validators.required));
        fg.addControl("comision_boca", new FormControl(this._comisionBoca, Validators.required));
        fg.addControl("nro_trx_externo", new FormControl(this._nroTrxExterno));
        fg.addControl("info_externo", new FormControl(this._infoExterno));
        return fg;
    }

    override async actualizarDatos( objeto: Record< string, any> ) {
        await super.actualizarDatos( objeto );
        this._idEmpresa = objeto.id_empresa;
        this._nombreEmpresa = objeto.nombre_empresa;
        this._idSucursal = objeto.id_sucursal;
        this._nombreSucursal = objeto.nombre_sucursal;
        this._idCaja = objeto.id_caja;
        this._nombreCaja = objeto.nombre_caja;
        this._idComercio = objeto.id_comercio;
        this._codigoComercio = objeto.codigo_comercio;
        this._nombreComercio = objeto.nombre_comercio;
        this._idServicio = objeto.id_servicio;
        this._codigoServicio = objeto.codigo_servicio;
        this._nombreServicio = objeto.nombre_servicio;
        this._referencia = objeto.referencia;
        this._idArqueoCaja = objeto.id_arqueo_caja;
        this._nroTrxArqueo = objeto.nro_transaccion_arqueo;
        this._estadoImpresion = objeto.estado_impresion;
        this._importe = objeto.importe;
        this._cobrado = objeto.cobrado;
        this._vuelto = objeto.vuelto;
        this._comisionComercio = objeto.comision_comercio;
        this._comisionServicio = objeto.comision_servicio;
        this._comisionBoca = objeto.comision_boca;
        this._nroTrxExterno = objeto.nro_trx_externo;
        this._infoExterno = objeto.info_externo;
    }

    override async guardar( service: CobroService ): Promise<IResponse> {
        return await service.post( this.serverJson );
    }

    override async actualizar( service: CobroService  ): Promise<IResponse> {
        return await service.put(this.id, this.serverJson);
    }

    override async eliminar( service: CobroService ): Promise<IResponse> {
        return await service.delete(this.id);
    }

}